<div class="d-flex">
  <div class="notification-button">
    <img class="notification-icon" [src]="'assets/icons/primary/Bell-On.svg'" alt="" />
  </div>
  <div
    appThrottleClick
    (throttleClick)="toggleDropdown()"
    id="dropdown{{ idSeed }}"
    [ngClass]="{ active: isNavItemActive$ | async }"
    class="nav-item custom-nav-item">
    <div class="nav-item-label" [ngClass]="{ 'multi-line-label': multiLineNavItem$ | async }">
      {{ navItem.name }}
    </div>
    <div *ngIf="hasIcons$ | async" class="nav-item-icon">
      <img [src]="navItem.iconSrc" alt="icon" i18n-alt class="nav-bar-icon" />
      <img [src]="navItem.iconFilledSrc" alt="icon-filled" i18n-alt class="nav-bar-icon-filled" />
    </div>
    <ul [class.open]="showDropdown$ | async" class="custom-nav-dropdown-menu">
      <ng-container *ngFor="let item of navItem.subItems">
        <ng-container>
          <app-nav-sub-item [navItem]="navItem" [subItem]="item" (subItemClicked)="closeDropdown()" />
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
